import { createHashRouter } from "react-router-dom";

import Layout from "./Layout";
import Contact from "./components/Contact";
import Founder from "./components/Founder";
import Galery from "./components/Galery";
import Home from "./components/Home";
import Offer from "./components/Offer";
import Support from "./components/Support";
import Trainings from "./components/Trainings";
import Trainer from "./components/Trainer";
import FacebookEmbed from "./components/FacebookEmbed";

export const router = createHashRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "trainings", element: <Trainings /> },
      { path: "offer", element: <Offer /> },
      { path: "founder", element: <Founder /> },
      { path: "trainer", element: <Trainer /> },
      { path: "support", element: <Support /> },
      { path: "galery", element: <Galery /> },
      { path: "contact", element: <Contact /> },
      { path: "social", element: <FacebookEmbed /> },
    ],
  },
]);